<script setup lang="js">
import { useCssVar, useNetwork } from '#imports'

const { rtt, isOnline } = useNetwork()
const { t } = useI18n()

const state = computed(() => {
  if (!isOnline.value) {
    return 4
  }
  if (rtt.value <= 100) {
    return 1
  }
  else if (rtt.value <= 300) {
    return 2
  }
  return 3
})

const functionalGreen3 = useCssVar('--functionalGreen3')
const functionalOrange3 = useCssVar('--functionalOrange3')
const functionalRed3 = useCssVar('--functionalRed3')
const textTextTertiary = useCssVar('--textTextTertiary')

const networkMap = computed(() => ({
  1: {
    text: t('网络稳定'),
    color: functionalGreen3.value,
  },
  2: {
    text: t('网络延迟'),
    color: functionalOrange3.value,
  },
  3: {
    text: t('网络不稳定'),
    color: functionalRed3.value,
  },
  4: {
    text: t('维护中'),
    color: textTextTertiary.value,
  },
}))

const network = computed(() => networkMap.value[state.value])

const getLineColor = computed(() => (index) => {
  if (index <= 4 - state.value) {
    return network.value.color
  }
  return textTextTertiary.value
})
</script>

<template>
  <ClientOnly>
    <div class="fixed bottom-0 left-0 right-0 z-50 flex items-center h-6 gap-1 px-4 text-xs border-t bg-fillPagePrimary text-textTertiary border-border" :style="{ color: network.color }">
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.52319 8.94434L3.52319 12.6281" :stroke="getLineColor(1)" stroke-width="1.5" stroke-linecap="round" />
        <path d="M8 6.42383L8 12.6281" :stroke="getLineColor(2)" stroke-width="1.5" stroke-linecap="round" />
        <path d="M12.4768 4.09766L12.4768 12.6285" :stroke="getLineColor(3)" stroke-width="1.5" stroke-linecap="round" />
      </svg>
      {{ network.text }}
    </div>
  </ClientOnly>
</template>
